var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#E7E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1041 25.4598C43.9881 25.4405 43.8527 25.4405 43.7366 25.4598C41.0669 25.3631 38.939 23.1771 38.939 20.4687C38.939 17.7024 41.1637 15.4777 43.93 15.4777C46.6964 15.4777 48.9211 17.7217 48.9211 20.4687C48.9018 23.1771 46.7738 25.3631 44.1041 25.4598Z",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1115 39.5432C44.7618 39.9881 47.6829 39.5238 49.7335 38.1503C52.4612 36.3319 52.4612 33.3527 49.7335 31.5343C47.6636 30.1607 44.7038 29.6965 42.0535 30.1607",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8316 25.4598C20.9477 25.4405 21.0831 25.4405 21.1992 25.4598C23.8688 25.3631 25.9968 23.1771 25.9968 20.4687C25.9968 17.7024 23.7721 15.4777 21.0057 15.4777C18.2394 15.4777 16.0146 17.7217 16.0146 20.4687C16.034 23.1771 18.162 25.3631 20.8316 25.4598Z",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8243 39.5432C20.174 39.9881 17.2528 39.5238 15.2023 38.1503C12.4746 36.3319 12.4746 33.3527 15.2023 31.5343C17.2722 30.1607 20.232 29.6965 22.8823 30.1607",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.497 39.9107C32.3809 39.8914 32.2455 39.8914 32.1294 39.9107C29.4598 39.814 27.3318 37.628 27.3318 34.9197C27.3318 32.1533 29.5565 29.9286 32.3229 29.9286C35.0892 29.9286 37.3139 32.1726 37.3139 34.9197C37.2946 37.628 35.1666 39.8334 32.497 39.9107Z",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8675 46.0045C24.1399 47.823 24.1399 50.8021 26.8675 52.6206C29.9628 54.6905 35.0312 54.6905 38.1265 52.6206C40.8541 50.8021 40.8541 47.823 38.1265 46.0045C35.0506 43.9539 29.9628 43.9539 26.8675 46.0045Z",
    stroke: "#15194B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.ff271f0b4ee3339bf562b4a4a71c4d9a.svg";
export { ForwardRef as ReactComponent };